export const theme = {
  media: {
    tablet: "768px",
    desktop: "960px",
    desktopLarge: "1400px",
  },
};
